import {
	ADD_COMPANIES
} from "../../constants"

export const addCompanies = ( companies ) => {
	return {
		type: ADD_COMPANIES,
		payload: {
			companies: companies
		}
	}
};


// WEBPACK FOOTER //
// ./src/api/companies/actions.js